/** Service Desk console: Settings -> Connectors (SD-SC-17), part A: list, connector detail, environments, defaults, call log, health. */
export const serviceConnectors = {
  title: "Mga Connector",
  subtitle:
    "Bawat external system na kinakausap ng Sagot sa pamamagitan ng API nito. May environment, naka-seal na credential at library ng mga pinangalanang operation ang bawat connector na tinatawag ng assistant, mga workflow, ng catalogue at ng mga order.",
  safety:
    "Sa mga pampublikong HTTPS host lang pumupunta ang mga tawag, hindi sinusundan ang mga redirect at muling sinusuri ang bawat address bago ang bawat pagtatangka. Data ang turing sa mga sagot ng API, hindi kailanman mga utos. Laging kailangan ng kumpirmasyon ang mga write operation bago ito mapatakbo ng assistant.",
  directionLead: "Ang mga connector ay para sa pagtawag ng Sagot sa iyong mga system. Para matawag ng iyong mga system ang Sagot, gumawa ng ",
  directionLink: "API key",
  directionTail: ".",
  navLocked: "(wala sa iyong plan)",
  actions: "Mga aksyon",
  upgrade: {
    title: "Kasama ang mga Connector mula sa {{plan}} plan",
    body: "Ikonekta ang iyong order system, CRM, o ang mga talaan ng estudyante at booking gamit ang API nila, at hayaang maghanap ang assistant at mga workflow. I-upgrade para buksan ang mga Connector.",
    cta: "Tingnan ang mga plan",
  },
  error: { title: "Hindi ma-load ang mga Connector", body: "Suriin ang koneksyon mo at subukan muli. Walang nabago." },
  missing: { title: "Wala rito ang connector na ito", body: "Maaaring nabura na ito. Bumalik sa listahan ng mga connector." },
  errors: {
    notInPlan: "Hindi kasama sa plan mo ang bahaging ito ng mga Connector.",
    planLimit: "Ubos na ang alokasyon ng plan mo para sa mga Connector. Mag-upgrade para makapagdagdag.",
    url: {
      empty: "Ilagay ang base URL.",
      invalid: "Hindi ito wastong web address.",
      https: "Dapat magsimula sa https:// ang address.",
      port: "Ang karaniwang HTTPS port (443) lang ang pinapayagan.",
      credentials: "Alisin ang user name at password sa address. Nasa mga naka-seal na secret ang mga credential.",
      private: "Hinaharang ang mga pribado, lokal at internal na address. Sa mga pampublikong HTTPS host lang tumatawag ang Sagot.",
    },
  },
  totals: { label: "Kabuuan ng mga connector", connectors: "Mga Connector", operations: "Mga Operation", active: "Aktibo", attention: "Kailangan ng pansin" },
  filters: { search: "Maghanap ng connector", searchPlaceholder: "Pangalan, host o paglalarawan", status: "Katayuan", allStatuses: "Lahat ng katayuan" },
  empty: {
    title: "Wala pang connector",
    body: "Magkonekta ng system na may API: magsimula sa template para sa uri ng system mo, mag-import ng OpenAPI file, Postman collection o curl command, o magsimula sa wala.",
  },
  noMatch: { title: "Walang tugmang connector", body: "Subukan ang ibang hanap o alisin ang filter ng katayuan." },
  managed: {
    title: "Mga managed na integration",
    name: "Zoho CRM at Google",
    note: "Mga managed na OAuth integration: hawak ng Sagot ang mga token at nire-refresh ang mga ito. Sa Settings > Integrations ito inaayos, hindi rito.",
    open: "Buksan ang Integrations",
  },
  card: {
    noDescription: "Wala pang paglalarawan",
    dryRun: "Dry run",
    host: "Host",
    operations: "Mga operation",
    calls: "Mga tawag, huling 24 oras",
    callsValue_one: "{{count}} tawag · error rate {{rate}}",
    callsValue_other: "{{count}} tawag · error rate {{rate}}",
    lastCall: "Huling tawag",
    usedBy: "Ginagamit ng",
    usedByValue_one: "{{count}} action, workflow o sync job",
    usedByValue_other: "{{count}} action, workflow o sync job",
    notUsed: "Wala pang gumagamit",
    open: "Buksan",
    openAria: "Buksan ang {{name}}",
    operationsAria: "Mga operation ng {{name}}",
    logsAria: "Mga call log ng {{name}}",
  },
  status: { active: "Aktibo", draft: "Draft", paused: "Naka-pause", error: "May error" },
  health: {
    healthy: "Malusog",
    degraded: "Bumababa ang performance",
    unhealthy: "May problema",
    none: "Wala pang tawag",
    indicators: "Mga indikasyon ng health",
    status: "Katayuan",
    window_one: "Huling {{count}} tawag",
    window_other: "Huling {{count}} tawag",
    errorRate: "Error rate",
    alertAt: "Alerto kapag lampas 20 %",
    p95: "p95 na latency",
    p50: "p50 {{ms}} ms",
    calls: "Mga tawag, huling {{hours}} oras",
    callsShort: "Mga tawag",
    failed: "Nabigo",
    quota: "{{used}} sa {{limit}} tawag ngayong buwan",
    quotaUnlimited: "{{used}} tawag ngayong buwan, walang limit",
    quotaExceeded: "Ubos na ang buwanang alokasyon ng mga tawag ng plan. Babalik sa \"babalikan ka namin\" ang mga daloy ng kliyente hanggang mag-renew ito.",
    alerts: "Mga alerto",
    noAlerts: "Walang bukas na alerto.",
    alertsAbout: "Nai-e-mail ang mga owner at admin na namamahala ng mga connector kapag lumampas sa 20 % ang error rate, patuloy na pumapalya ang authentication o malapit nang mag-expire ang isang secret (isang beses lang bawat 6 na oras).",
    secretExpiring: "Mag-e-expire sa {{date}} ang secret na \"{{slot}}\". I-rotate ito bago noon.",
    unsafeKinds_one: "{{count}} nailathalang operation ang hindi magkatugma ang method at uri (halimbawa, DELETE na naka-read), kaya nilalampasan nito ang kumpirmasyong kailangan ng pagbabago. Buksan ito, ayusin ang uri at ilathala ulit.",
    unsafeKinds_other: "{{count}} nailathalang operation ang hindi magkatugma ang method at uri (halimbawa, DELETE na naka-read), kaya nilalampasan ng mga ito ang kumpirmasyong kailangan ng pagbabago. Buksan ang bawat isa, ayusin ang uri at ilathala ulit.",
    perOperation: "Ayon sa operation",
    noCalls: "Wala pang tawag sa panahong ito.",
    controls: "Breaker, capture at retention",
    breakers: "Circuit breaker",
    breaker: { closed: "Sarado", open: "Bukas (naka-pause)", half_open: "Half-open (sinusubok)" },
    capture: "Debug capture sa loob ng 24 oras",
    captureHint: "Nag-iimbak ng redacted na hugis ng request at sagot para sa troubleshooting. Kusang namamatay pagkatapos ng 24 oras.",
    captureUntil_one: "Bukas hanggang {{date}} · {{count}} palitan ang nakuha",
    captureUntil_other: "Bukas hanggang {{date}} · {{count}} palitan ang nakuha",
    captureOn: "Bukas ang debug capture sa loob ng 24 oras",
    captureOff: "Sarado ang debug capture",
    retention: "Itago ang call log sa loob ng",
    retentionHint: "Mula 7 hanggang 90 araw. Hindi kailanman iniimbak ang mga body, halaga ng header at personal na field.",
    retentionSaved: "Na-update ang retention ng call log",
    days_one: "{{count}} araw",
    days_other: "{{count}} araw",
    clearCache: "Burahin ang mga naka-cache na sagot",
    cacheCleared_one: "{{count}} naka-cache na sagot ang naalis",
    cacheCleared_other: "{{count}} naka-cache na sagot ang naalis",
  },
  environment: { production: "Production", sandbox: "Sandbox", other: "{{name}}" },
  kind: { generic_rest: "Generic REST" },
  kindOf: { read: "Basa", write: "Sulat", destructive: "Mapanira" },
  callers: { staff: "Staff", workflows: "Mga workflow", assistant: "Assistant", contacts: "Mga contact", guests: "Mga bisita" },
  tabs: {
    label: "Mga seksyon ng connector",
    overview: "Pangkalahatan",
    operations: "Library ng mga operation",
    webhooks: "Mga webhook papasok",
    sync: "Mga sync job",
    logs: "Mga call log",
    health: "Health",
  },
  header: {
    status: "Katayuan ng connector",
    pause: "I-pause",
    resume: "Ituloy",
    activate: "I-activate",
    paused: "Naka-pause ang {{name}}. Mabilis na papalya ang mga tawag hanggang maituloy ito.",
    activated: "Aktibo na ang {{name}}",
    export: "I-export",
    exported: "Na-save ang export (walang secret sa loob)",
  },
  new: {
    button: "Bagong connector",
    title: "Bagong connector",
    subtitle:
      "Magkonekta ng anumang system na may HTTPS API: order o purchasing system, CRM, mga talaan ng estudyante, HR o klinika, mga booking, billing, ticket tool o sarili mong internal API.",
    intro: "Piliin kung paano magsisimula. Maaari mong baguhin ang lahat ng malilikha mo.",
    startFrom: "Paano mo gustong magsimula?",
    generic: "Generic REST",
    genericHint: "Magsimula sa wala at magdagdag ng mga operation nang mano-mano.",
    templates: "Mga starter template ayon sa uri ng system",
    templatesHint: "Mga halimbawang operation na ie-edit, hindi code: ilagay ang base URL mo at ayusin ang mga path ayon sa system mo.",
    moveHere: "Ilipat ang connector sa pagitan ng mga workspace",
    importFile: "Mag-import ng export file",
    importFileHint: "Connector na na-export mula sa Sagot (walang secret sa loob).",
    fileInvalid: "Hindi ito export file ng connector.",
    back: "Bumalik",
    name: "Pangalan ng connector",
    nameRequired: "Bigyan ng pangalan ang connector.",
    description: "Paglalarawan (opsyonal)",
    environment: "Environment",
    environmentHint: "Magsimula sa sandbox kung mayroon ang system.",
    baseUrl: "Base URL",
    baseUrlHint: "HTTPS, port 443, pampublikong address. Sinusuri sa bawat tawag.",
    exampleOperations: "Mga halimbawang operation",
    create: "Likhain ang connector",
    created: "Nalikha ang {{name}}",
    someFailed_one: "{{count}} halimbawang operation ang hindi naidagdag. Tingnan ang listahan ng mga operation.",
    someFailed_other: "{{count}} halimbawang operation ang hindi naidagdag. Tingnan ang listahan ng mga operation.",
  },
  environments: {
    title: "Mga environment",
    environment: "Environment",
    state: "Kalagayan",
    active: "Aktibo",
    inactive: "Hindi aktibo",
    activeLabel: "Aktibong environment",
    noneActive: "Walang aktibong environment",
    makeActive: "Gawing aktibo",
    add: "Magdagdag ng environment",
    edit: "I-edit ang {{name}}",
    delete: "Burahin ang {{name}}",
    key: "Key ng environment",
    keyHint: "Maliliit na titik, numero at underscore.",
    keyInvalid: "Gumamit ng maliliit na titik, numero at underscore, magsimula sa titik.",
    keyTaken: "May environment na ang connector na ito na may ganyang key.",
    none: "Wala pang environment. Magdagdag ng isa na may base URL para matawagan ang system na ito.",
    dialogHint: "Ang base URL at kung paano nag-a-authenticate ang Sagot doon. Hiwalay na itinatakda ang mga halaga ng secret at hindi na muling ipinapakita.",
    activateNow: "Gawing aktibong environment ito",
    saved: "Na-save ang environment",
    deleted: "Naalis ang {{name}}",
    deleteTitle: "Alisin ang {{name}} na environment?",
    deleteBody: "Hindi na matatawagan ng mga operation ang address na ito. Hindi maaalis ang aktibong environment.",
    deleteConfirm: "Alisin ang environment",
    switchTitle: "Lumipat sa {{name}}?",
    switchBody:
      "Mula ngayon, ang environment na ito na ang tatawagan ng bawat operation ng connector na ito, kasama ang mga ginagamit ng assistant at mga workflow. Naka-audit ang pagbabago.",
    switchConfirm: "Lumipat ng environment",
    switched: "Aktibong environment: {{name}} · naka-log sa audit",
    audited: "Naka-audit ang paglipat ng aktibong environment at naaangkop ito sa bawat operation ng connector na ito.",
  },
  defaults: {
    title: "Mga default ng request",
    edit: "I-edit ang mga default",
    saved: "Na-save ang mga default",
    headers: "Mga default na header",
    headersHint: "Ipinapadala sa bawat tawag, hanggang {{max}}. Nasa authentication ang mga credential, hindi rito.",
    noHeaders: "Wala",
    timeout: "Timeout (ms)",
    timeoutHint: "1,000 hanggang 30,000. Maaaring magtakda ng sarili ang isang operation.",
    timeoutValue: "{{ms}} ms",
    rate: "Rate limit (request kada segundo)",
    rateHint: "Token bucket kada connector, hanggang {{max}}.",
    rateValue_one: "{{count}} request kada segundo",
    rateValue_other: "{{count}} request kada segundo",
    rateInvalid: "Gumamit ng buong numero mula 1 hanggang {{max}}.",
    attempts: "Mga pagtatangka kada tawag",
    attemptsHint: "Ang mga ligtas na method lang ang inuulit; hindi kailanman bulag na inuulit ang mga write.",
    attemptsValue_one: "{{count}} pagtatangka",
    attemptsValue_other: "{{count}} pagtatangka",
    attemptsInvalid: "Gumamit ng buong numero mula 1 hanggang {{max}}.",
    redirects: "Mga redirect",
    redirectsHint: "Hindi sinusundan ang redirect maliban kung pinapayagan mo ang mga hop sa parehong host.",
    redirectsNone: "Hindi sinusundan",
    redirectsSameHost: "Parehong host lang (hanggang 3 hop)",
    breaker: "Circuit breaker",
    breakerValue: "Ipo-pause ng 5 minuto ang connector kapag 50 % ng 20 tawag ang pumalya",
    limit: "Laki ng sagot",
    limitValue: "1 MB kada sagot; pumapalya bilang masyadong malaki ang mas malaki",
    signature: "I-sign ang mga request gamit ang X-Sagot-Signature",
    signatureHint: "Nagpapadala rin ng Sagot signature header na nilagdaan gamit ang slot na signing_secret.",
    fixedIp: "Kailangan ng fixed na outbound IP",
    fixedIpHint:
      "Dadaan na ang mga tawag sa system ninyo sa mga fixed na outbound address ng Sagot, kaya maa-allow ninyo ang mga ito sa firewall. Kapag hindi pa naka-set up ang mga fixed address para sa workspace na ito, tinatanggihan ang tawag nang may blocked_destination.",
    fixedIpLink: "Tingnan ang Mga outbound IP address sa Data at privacy",
    fixedIpReadOn: "Dumadaan ang mga tawag sa mga fixed na address ng Sagot. Tinatanggihan ang mga ito nang may blocked_destination kung hindi pa naka-set up ang mga iyon.",
    fixedIpReadOff: "Maaaring manggaling sa alinmang address ng Sagot ang mga tawag.",
    tokenDomains: "Mga pinapayagang token domain",
    tokenDomainsHint: "Mga host na maaaring gamitin ng OAuth token endpoint bukod sa mga base URL, pinaghihiwalay ng espasyo.",
    on: "Bukas",
    off: "Sarado",
    dryRun: "Dry run para sa buong connector",
    dryRunHint: "Binubuo at nilo-log ang bawat write pero hindi ipinapadala. Gamitin sa mga pilot at shadow period.",
    dryRunOn: "Bukas ang dry run: nilo-log ang mga write, hindi ipinapadala",
    dryRunOff: "Sarado ang dry run: ipinapadala ang mga write",
  },
  safetyCard: {
    title: "Kaligtasan",
    guard:
      "Mga pampublikong HTTPS host lang, patay ang redirect. Tinatanggihan ang mga pribado, link-local at metadata na address, at muling nire-resolve ang DNS bago ang bawat pagtatangka.",
    reconcile: "Ilagay muli ang mga secret na ito (hindi nailipat):",
    allowlist: "Allow-list ng host",
    usedBy: "{{actions}} action · {{workflows}} workflow · {{profiles}} profile · {{jobs}} sync job",
    logs: "Method, operation, katayuan at oras ang itinatago ng mga log. Hindi kailanman iniimbak ang mga body, halaga ng header at personal na field.",
    delete: "Burahin ang connector",
    deleteTitle: "Burahin ang {{name}}?",
    deleteBody: "Aalisin ang connector, ang mga operation at ang mga secret nito. Hindi mabubura ang connector na ginagamit pa ng mga action o workflow: tanggalin muna ang pagkakaugnay.",
    deleteConfirm: "Burahin ang connector",
  },
  operations: {
    intro: "Mga pinangalanang operation na may paglalarawan para sa assistant, parameter schema at mga naka-save na halimbawa. Tinatawag ng assistant at mga workflow ang mga ito sa pangalan, halimbawa ang get_order_status.",
    tableLabel: "Mga operation ng {{name}}",
    operation: "Operation",
    path: "Path",
    kind: "Uri",
    status: "Bersyon",
    who: "Sino ang maaaring tumawag",
    filter: "I-filter ang mga operation",
    all: "Lahat",
    read: "Basa",
    write: "Sulat",
    new: "Bagong operation",
    import: "Mag-import ng mga operation",
    edit: "I-edit",
    view: "Tingnan",
    editAria: "I-edit ang {{key}}",
    deleteAria: "Burahin ang {{key}}",
    draftOnly: "Draft, hindi pa nailalathala",
    published: "Nailathala v{{version}}",
    hasDraft: "May pagbabago sa draft",
    notPublished: "Ilathala para maialok",
    emptyTitle: "Wala pang operation",
    emptyBody: "Mag-import ng OpenAPI o Postman file, mag-paste ng curl command, o magdagdag ng operation nang mano-mano.",
    noMatchTitle: "Walang operation sa filter na ito",
    noMatchBody: "Palitan ang filter o magdagdag ng operation.",
    deleteTitle: "Burahin ang {{key}}?",
    deleteBody: "Aalisin ang mga bersyon at halimbawa nito. Hindi mabubura ang operation na ginagamit ng mga agent action: tanggalin muna ang pagkakaugnay.",
    deleteConfirm: "Burahin ang operation",
    deleted: "Nabura ang {{name}}",
  },
  calls: {
    intro: "Nilo-log ang bawat tawag na may operation, environment, tumawag, katayuan at oras, at itinatago nang {{days}} araw. Hindi kailanman iniimbak ang mga body, halaga ng header at personal na field; pinaikli ang mga idempotency key.",
    export: "I-export bilang CSV",
    exported: "Na-export ang call log",
    exportFailed: "Hindi ma-export ang call log. Subukan muli.",
    operation: "Operation",
    allOperations: "Lahat ng operation",
    status: "Katayuan",
    allStatuses: "Lahat ng katayuan",
    environment: "Environment",
    allEnvironments: "Lahat ng environment",
    outcome: { success: "Nagtagumpay", failed: "Nabigo", refused: "Tinanggihan (hindi ipinadala)" },
    time: "Oras",
    caller: "Tumawag",
    ref: { test: "Test console", manual_run: "Mano-manong takbo", workflow_run: "Workflow", action_run: "Action ng assistant", sync_run: "Sync job", order: "Order", ticket: "Ticket" },
    latency: "Latency",
    attempts: "Mga pagtatangka",
    key: "Idempotency key",
    error: "Error",
    tableLabel: "Call log",
    emptyTitle: "Wala pang tawag",
    emptyBody: "Lalabas dito ang mga tawag sa sandaling tumakbo ang isang operation.",
    emptyFiltered: "Walang tawag na tugma sa mga filter na ito.",
    range: "{{first}} hanggang {{last}} sa {{total}}",
    previous: "Nakaraan",
    next: "Susunod",
  },
  rows: {
    add: "Magdagdag",
    nameOf: "{{legend}}, pangalan {{index}}",
    valueOf: "{{legend}}, halaga {{index}}",
    remove: "Alisin ang {{legend}} {{index}}",
  },
};
